import { Mail } from '../components/icons';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import Input from '../components/Input';
import ThemeToggle from '../components/ThemeToggle';
import { authService } from '../services/authService';
import { useToast } from '../store/toastContext';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ForgotPasswordPage() {
  const { pushToast } = useToast();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!emailRegex.test(email)) {
      pushToast({ type: 'error', title: 'Email inválido', description: 'Digite um email válido.' });
      return;
    }

    setLoading(true);
    try {
      const res = await authService.forgotPassword(email);
      setMsg(res.message);
      pushToast({ type: 'info', title: 'Recuperação enviada' });
    } catch (err) {
      pushToast({ type: 'error', title: 'Falha', description: err instanceof Error ? err.message : 'Tente novamente.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bgLight px-4 py-8 dark:bg-bgDark">
      <div className="mx-auto max-w-lg rounded-3xl border border-borderLight bg-cardLight p-6 shadow-xl dark:border-borderDark dark:bg-cardDark">
        <div className="mb-5 flex items-center justify-between">
          <Link to="/login" className="text-sm font-semibold text-primary dark:text-cta">
            Voltar
          </Link>
          <ThemeToggle />
        </div>

        <h1 className="text-2xl font-bold">Esqueci minha senha</h1>
        <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">Se existir conta, enviamos o link para redefinição.</p>

        <form className="mt-6 space-y-4" onSubmit={onSubmit}>
          <Input label="Email" value={email} onChange={(e) => setEmail(e.target.value)} iconLeft={<Mail className="h-4 w-4" />} />
          <Button fullWidth disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar link de recuperação'}
          </Button>
          {msg ? <p className="rounded-lg bg-cta/10 px-3 py-2 text-sm font-medium text-cta">{msg}</p> : null}
        </form>
      </div>
    </div>
  );
}
